import { takeEvery, all } from 'redux-saga/effects';

import { USER_UPLOAD_SELECTED_USER_DOCUMENT_REQUEST } from '../../redux/user/types';

import uploadDocs from './uploadDocs';

export default function*() {
    yield all([takeEvery(USER_UPLOAD_SELECTED_USER_DOCUMENT_REQUEST, uploadDocs)]);
}
